/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  /**
  *   Rebuy: Cart Change
  *   reference: https://developers.rebuyengine.com/reference/cart-methods
  */
  document.addEventListener('rebuy:cart.change', function (event) {
    /**
    *   Update Pillow Quantity
    *   Sets the pillow quantity when items in the cart have changed
    */
    function updateFreePillowsQuantity() {
      const Cart = window.Rebuy.Cart;
      let productIds = [7007705399339, 4472568447019, 1811177930795, 6551185293355];
      let { cart } = event.detail.cart;

      if (!cart) return;

      let eligibleProducts = cart.items.filter((item) => productIds.includes(item.product_id));

      eligibleProducts.forEach(product => {
        let matchingPillow = cart.items.find((item) => Number(item.properties.mattress) == product.variant_id);
        let updatedQuantity = product.quantity * 2;

        if (!matchingPillow) return;

        if (matchingPillow.quantity !== updatedQuantity) {
          Cart.changeItem({ id: matchingPillow.key, quantity: updatedQuantity });
        }
      });
    }

    /**
    * Update Cart Count
    * Matches the headter cart quantity with rebuy cart quantity
    */
    function updateCartCount(event) {
      const cartCountElement = document.querySelector('.cart-item-count');
      let itemCount = event?.detail?.cart?.cart?.item_count;

      if (!cartCountElement || !itemCount) return;

      cartCountElement.innerHTML = `(${itemCount})`;
    }

    updateFreePillowsQuantity();
    updateCartCount();
  });



  /**
  *   Video Mute
  */
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-video-mute').forEach(muteButton => {
      muteButton.addEventListener('click', () => {
        const video = muteButton.parentElement.querySelector('.video__player video');

        if (!video) return;

        video.muted = !video.muted;
        muteButton.classList.toggle('is-unmuted', !video.muted);
        muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });
    });
  });



  /**
  *   Replace Trademark and Registered Symbols
  */
  document.addEventListener('DOMContentLoaded', () => {
    const els = '.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6, .font-heading, .rte p, .metafield-rich_text_field li, .slide__text, .column-item__text > p > strong, .icons-row-item__text > p, .navtext';
    document.querySelectorAll(els).forEach((element) => {
      const html = element.innerHTML;
      const regex = /™|®/g;
      const newContent = html.replace(regex, '<span class="mark">$&</span>');
      element.innerHTML = newContent;
    });
  });



  /**
  *   Pause background video when lightbox is opened
  */
  document.addEventListener('DOMContentLoaded', () => {
    const playBtn = document.querySelector('[data-video-play]');

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        const wrapper = playBtn.closest('[data-video-wrapper]');
        const bg = wrapper.querySelector('.video-background video');
        const loader = document.querySelector('.pswp--custom-loader');

        if (bg && loader) {
          bg.pause();

          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (!loader.classList.contains('pswp--open')) {
                  bg.play();
                }
              }
            });
          });

          observer.observe(loader, {
            attributes: true,
            attributeFilter: ['class']
          });
        }
      });
    }
  });

  /**
  *   Accordion Tab Switching
  */
  document.addEventListener('DOMContentLoaded', () => {
    const accordionSections = document.querySelectorAll('[data-section-type="accordions"]');

    accordionSections.forEach(section => {
      const tabs = section.querySelectorAll('.accordion__tab');
      const tabContents = section.querySelectorAll('.accordion__tab-content');

      if (tabs.length === 0) return;

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const targetTab = tab.getAttribute('data-tab');
          const targetContent = section.querySelector(`[data-tab-content="${targetTab}"]`);

          tabs.forEach(t => t.classList.remove('accordion__tab--active'));
          tab.classList.add('accordion__tab--active');

          tabContents.forEach(content => {
            content.classList.add('accordion__tab-content--hidden');
          });

          if (targetContent) {
            targetContent.classList.remove('accordion__tab-content--hidden');
          }
        });
      });
    });
  });
})();